import Card from '../card';

/**
 * The AboutLicenses component is used on the About page to show license information
 * about any third party libraries or resources used in the web application.
 *
 * props: none
 */

const AboutLicenses = () => (
	<Card cardTitle="Licenses">
		<p>The rainfall icons displayed on the home page when it is raining are created by Stardock (http://www.stardock.com).
			Use of the icons requires a link their <a target="_blank" href="assets/licenses/stardock-permissions.txt">permissions file</a>.
		</p>
	</Card>
);

export default AboutLicenses;



// WEBPACK FOOTER //
// ./components/about/about-licenses.js